export default "__VITE_ASSET__BxNglnzD__"